// extracted by mini-css-extract-plugin
module.exports = {"b8b7go7":"b8b7go7","a2f4tzd":"a2f4tzd","fdq63sg":"fdq63sg"};